import ViewManager from "../../core/src/utils/ViewManager";
import CommManager from "../../core/src/controllers/CommManager";
import BetModel from "../../core/src/model/BetModel";
import GameModel from "../../core/src/model/GameModel";
import requestRegister from "../../core/src/server/requests/RequestRegister";
import { State } from "../../core/src/states/State";
import UIController from "../../core/src/ui/UIController";
import { UIModes, UIStates } from "../../core/src/ui/UIStates";
import AutoplayModel from "../../core/src/model/AutoplayModel";
import KeyboardManager, { Key } from "../../core/src/utils/KeyboardManager";
import SpinModel from "../../core/src/model/SpinModel";
import CommandManager from "../../core/src/commands/CommandManager";
import { Commands } from '../../core/src/commands/CommandEnum';
import { DefaultLayers } from "../../core/src/utils/Layers";
import ReelGroup from "../../core/src/views/ReelGroup";
import VendorModel from "../model/VendorModel";

export default class Idle extends State {
    protected balanceIntervalID: any;
    protected balanceRequestSent = false;

    public enter(): void {
        super.enter();

        let winContainer = ViewManager.getLayer(DefaultLayers.BetBar)
            .getCurrentScene()
            .groups.get("win");

        if (winContainer) {
            winContainer.visible = true;
        }

        const scene = ViewManager.getLayer(
            DefaultLayers.Reels
        ).getCurrentScene();

        const reelGroup = scene.getSubView("ReelGroup") as ReelGroup;
        if(VendorModel.allowSwipeSpin) {
            reelGroup.enableSwipeSpin();
        } else {
            reelGroup.disableSwipeSpin();
        }

        UIController.setMode(UIModes.DEFAULT);
        UIController.setState(UIStates.IDLE);
        if (AutoplayModel.isAutoSpinActive()) {
            this.exit();
            return;
        }

        if (AutoplayModel.autoSpinLimitReached) {
            UIController.toggleComponent("autoplayLimitPopup");
        }

        if (GameModel.spaceToSpin) {
            if (KeyboardManager.isPressed(Key.SPACE)) {
                this.spinWithKey();
            } else {
                KeyboardManager.onKey("pressed", Key.SPACE, this.spinWithKey, this);
            }
        }
    }

    protected spinWithKey() {
        if (GameModel.spaceToSpin) {
            CommandManager.execute(Commands.SPIN);
        }
    }

    public exit(): void {
        if (GameModel.spaceToSpin) {
            KeyboardManager.offKey("pressed", Key.SPACE, this.spinWithKey, this);
        }
        
        clearInterval(this.balanceIntervalID);
        this.balanceRequestSent = false;
        // SpinModel.isInRespins = false;
        super.exit();
    }

    public canExit(): boolean {
        return true;
    }

    protected updateBalance() {
        if (this.balanceRequestSent) {
            return;
        }
        CommManager.send(
            requestRegister.get("balanceRequest"),
            function (data: any) {
                this.onBalanceRecieved(data.data);
            },
            this
        );
    }

    protected onBalanceRecieved(data) {
        this.balanceRequestSent = false;
        BetModel.balance = data.balance;
    }

    protected startBalanceCounter() {
        this.balanceIntervalID = setInterval(
            this.updateBalance.bind(this),
            5000
        );
    }
}
